import type { IAnalyticsMetricValue } from "types/analyticsTypes"

export function fmtMetric(val: IAnalyticsMetricValue): string {
  if (val.type === "numeric") {
    return val.numericAvg === null ? "—" : val.numericAvg.toFixed(2)
  }
  if (val.type === "boolean") {
    return val.booleanRate === null ? "—" : `${val.booleanRate.toFixed(1)}% True`
  }
  if (val.type === "categorical") {
    if (val.categoricalMode === null) return "—"
    const pct = val.categoricalModeRate !== null ? ` (${val.categoricalModeRate.toFixed(1)}%)` : ""
    return `${val.categoricalMode}${pct}`
  }
  return "—"
}
